import { Injectable } from "@angular/core";
import { API_METHODS, API_URL } from "common/constants/sm-constants";
import { environment } from 'src/environments/environment';
import { FeedbackMappingModel } from "common/models/page-models/Feedback-Mapping/feedback-mapping-data-model";
import { FormDataService } from "../../base-data-services/form-data.service";
import { SmApiService } from "common/services/core-services/sm-api.service";
import { SystemService } from "common/services/core-services/system.service";

@Injectable({
    providedIn: 'root'
})
export class FeedbackMappingFormDataService extends FormDataService<FeedbackMappingModel> {
    constructor(http: SmApiService, protected override  ss: SystemService) {
        super(API_URL.addFeedbackList, http, ss);
    }

    createInstance():FeedbackMappingModel {
        return new FeedbackMappingModel();
    }
     getEditUrlAndMethod() {
        const edit = {
            url: environment.apiUrl + API_URL.getCategorydepartmentById,
            method: API_METHODS.get
        }
        return edit;
    }
    // postFeedbackMappingData(data,url:string): Promise<any> {
    //     return new Promise((resolve, reject) => {
    //       // const type = this.getOperationType(data);
    //       // const url = environment.apiUrl + API_URL.student_submit_details;
    
    //       this.apiService
    //         .postData(url, this.convertFormData(data))
    //         .then((res) => {
    //           resolve(res);
    //         })
    //         .catch((err) => {
    //           reject(err);
    //         });
    //     });
    //   }
   
}

export { FormDataService };
